<template>
  <div class="about">
    <h1>Member Account Resources and Contacts</h1>
    <h2>Invoice Contact</h2>
    <b-row>
      <b-col md="8" lg="6" xl="4">
        <p>
          This individual or group (email alias) will receive all communications
          regarding invoicing for Associate Membership upgrades or renewals.
          This information will <strong>not</strong> be visible to users from
          your company.
        </p>
      </b-col>
    </b-row>
    <!-- forms -->
    <b-row>
      <!-- invoice contact form -->
      <b-col class="mt-3" md="8" lg="6" xl="4">
        <ContactForm title="Invoice Contact" memberContactType="2" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ContactForm from "@/components/ContactForm";
export default {
  name: "Invoice",
  components: { ContactForm }
};
</script>
